import { defineStore } from 'pinia';
import Network from "~/utils/network";

const urls = {
    documentWithId: (id) => `/administration/document-prompt/${id}`,
};

export const useDocumentPromptStore = defineStore('documentPrompt', {
    state: () => ({
        documentList: [],
        documentData: {},
    }),
    actions: {
        fetchOne: async function (id) {
            try {
                let data = await Network.http(urls.documentWithId(id));
                this.saveOne(data);
            } catch (err) {
                console.log(err);
                await Promise.reject(err);
            }
        },
        saveOne: function (data)  {
            this.documentData[data.id] = data;
        },
    },
});
